import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { UndefinedFileTag } from '@portal-core/reports/models/undefined-file-tags.model';

@CollectionStateSelectors({
  stateType: ProjectReportsUndefinedFileTagsState
})
@State<ProjectReportsUndefinedFileTagsState>({
  name: ProjectReportsUndefinedFileTagsState.source
})
@Service({ autoProvided: false })
export class ProjectReportsUndefinedFileTagsState extends CollectionStateBase {
  static override source = 'ProjectReportsUndefinedFileTags';
  getSource(): string {
    return ProjectReportsUndefinedFileTagsState.source;
  }
}

@Service()
export class ProjectReportsUndefinedFileTagsDataService extends CollectionDataServiceBase<UndefinedFileTag> {
  protected readonly stateType = ProjectReportsUndefinedFileTagsState;
}
